/* import __COLOCATED_TEMPLATE__ from './data-section.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import { ReviewType } from 'embercom/models/content-service/content-review-request';
import type ContentSnippet from 'embercom/models/content-service/content-snippet';
import { inject as service } from '@ember/service';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    activeContent: ContentSnippet;
  };
}

export default class DataSection extends Component<Signature> {
  @service declare appService: AppService;

  get content() {
    return this.args.activeContent;
  }

  get showContentType() {
    if (isEmpty(this.content.firstContentReviewRequest)) {
      return true;
    }
    return this.content.firstContentReviewRequest?.reviewType !== ReviewType.CREATE_CONTENT;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Snippet::DataSection': typeof DataSection;
    'knowledge-hub/content-editor/snippet/data-section': typeof DataSection;
  }
}
